import BuildingGeneral from '@/components/DynamicComponents/Projects/Navigation/BuildingGeneral'
import InteriorInfo from '@/components/DynamicComponents/Projects/Navigation/InteriorInfo'
import SiteTakeOffs from '@/components/DynamicComponents/Projects/Navigation/SiteTakeoff'
import BuildingShell from '@/components/DynamicComponents/Projects/Navigation/BuildingShell'
import SpecialtyInfo from '@/components/DynamicComponents/Projects/Navigation/SpecialtyInfo'
import LinkAsset from '@/components/DynamicComponents/Projects/LinkAsset'
import ProjectDrawer from '@/components/DynamicComponents/Projects/Drawer'
import ActualCost from '@/components/DynamicComponents/Projects/Navigation/ActualCost'
import Estimate from '@/components/DynamicComponents/Projects/Navigation/Estimates'
import EstimateInfo from '@/components/DynamicComponents/Projects/EstimateInfo'
import IndirectCost from '@/components/DynamicComponents/Projects/Navigation/IndirectCost'
import IndirectCostInfo from '@/components/DynamicComponents/Projects/IndirectCostInfo'
import exportTemplates from '@/components/DynamicComponents/Projects/Export'
import Vue from 'vue'
import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import { calculateHeight, showNotification } from '@/services/calculate'
import _ from 'lodash'
import { mapState } from 'vuex'
import { socketEvents, checkEvents } from '@/services/config'
import { formatCurrency, formatValue } from '@/services/convert'

export default {
  props: [
    'templateData',
    'projectData',
    'screenIndentifier',
    'screenData',
    'dropdownData',
    'componentKey',
    'analysisTypeId',
    'enableAPI',
    'showDrawer',
    'screen',
    'collapsed',
    'columnSettings',
    'projectAssets',
  ],
  components: {
    BuildingGeneral,
    BuildingShell,
    InteriorInfo,
    SiteTakeOffs,
    ProjectDrawer,
    'link-asset': LinkAsset,
    ActualCost,
    exportTemplates,
    Estimate,
    EstimateInfo,
    IndirectCost,
    IndirectCostInfo,
  },
  data() {
    return {
      list: [],
      componentProjectKey: 0,
      activeKey: [],
      height: '200px',
      visible: false,
      assetId: undefined,
      childComponent: null,
      child: new Vue(),
      isShow: false,
      screen_Name: null,
      loading: false,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      expandedKeys: [],
      autoExpandParent: true,
      selectedKeys: [],
      treeData: [],
      visibleDrawer: true,
      loadClone: false,
      assetsList: null,
      expandedFromKeys: [],
      interiorInfoAssets: null,
      visibleFrom: false,
      componentId: 0,
      componentName: '',
      interiorInfoClone: [],
      checkedAll: false,
      sourceList: [],
      source: 0,
      tenantApproachId: undefined,
      structureProfileId: undefined,
      tempInteriorInfoClone: [],
      cloneTitle: undefined,
      sidebarView: false,
      tenanatCloneData: null,
      formGeneral: null,
      tenanatIds: [],
      exportClicked: false,
      formatCurrency: formatCurrency,
      parentLevelTotal: 0,
      levels: [],
      visibleEstimateInfo: false,
      url: undefined,
      estimateInfoCount: 0,
      visibleIndirectCostInfo: false,
      assetDescription: undefined,
    }
  },
  computed: mapState(['assets']),
  mounted() {
    this.$socketHub.$off('message-received')
    this.$socketHub.$on('message-received', this.recievedMessage)
    this.$root.$off('cloneSuccess')
    this.$root.$on('cloneSuccess', this.cloneSuccess)
    this.$root.$off('onCloneClick')
    this.$root.$on('onCloneClick', this.onCloneClick)
    this.loadComponent()
    this.getScreenInfo()
    const listElm = document.querySelector('#projectdetails')
    listElm.addEventListener('scroll', e => {
      if (listElm.scrollTop > 40) {
        if (!this.isShow) {
          this.isShow = true
        }
      } else {
        this.isShow = false
      }
    })
  },
  beforeDestroy() {
    this.$socketHub.$off('message-received')
    this.$root.$off('onCloneClick')
    this.$root.$off('cloneSuccess')
  },
  watch: {
    collapsed() {
      this.sidebarView = this.collapsed
    },
  },
  methods: {
    loadComponent() {
      switch (this.screenIndentifier) {
        case 'Project Building General':
          this.childComponent = BuildingGeneral
          this.screen_Name = 'Building General'
          this.componentName = 'Building General'
          this.componentId = 1
          this.cloneTitle = 'Building General'
          break
        case 'Project Building Shell':
          this.childComponent = BuildingShell
          this.screen_Name = 'Acquisition - Building Shell'
          this.componentName = 'Building Shell'
          this.componentId = 2
          this.cloneTitle = 'Building Shell'
          break
        case 'Project Interior Info':
          this.childComponent = InteriorInfo
          this.screen_Name = 'Acquisition - Interior Info'
          this.componentName = 'Interior Info'
          this.componentId = 3
          this.cloneTitle = 'Interior Info'
          this.getProjectAssets()
          break
        case 'Project Speciality Information':
          this.childComponent = SpecialtyInfo
          this.screen_Name = 'Acquisition - Common Area'
          this.componentName = 'Speciality Information'
          this.componentId = 4
          this.cloneTitle = 'Common Area'
          break
        case 'Project Site Takeoffs':
          this.childComponent = SiteTakeOffs
          this.screen_Name = 'Acquisition - Site Takeoffs'
          this.componentName = 'Site Takeoffs'
          this.componentId = 5
          this.cloneTitle = 'Site Takeoffs'
          break
        case 'Project Actual Cost':
          this.childComponent = ActualCost
          this.screen_Name = 'New Construction - Actual Cost'
          this.componentName = 'Actual Cost'
          this.componentId = 6
          this.cloneTitle = 'Actual Cost'
          break
        case 'Project Estimates':
          this.childComponent = Estimate
          this.screen_Name = 'New Construction - Project Estimates'
          this.componentName = 'Project Estimates'
          this.componentId = 7
          this.cloneTitle = 'Project Estimates'
          break
        case 'Project Indirect Cost':
          this.childComponent = IndirectCost
          this.screen_Name = 'New Construction - Project Indirect Cost'
          this.componentName = 'Project Indirect Cost'
          this.componentId = 8
          this.cloneTitle = 'Project Indirect Cost'
          break
      }
    },

    getScreenInfo() {
      if (this.enableAPI) {
        this.getProjectAssets()
      } else {
        this.list = this.$store.state.settings.assets
        this.assetsList = JSON.stringify(this.list)
        this.height = calculateHeight('projectdetails', true)
        if (this.list.length > 0) {
          this.setActiveKey(this.list)
        }
      }
    },

    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },

    onCheck(checkedKeys, event) {
      this.selectedKeys = checkedKeys
      if (this.screenIndentifier === 'Project Interior Info') {
        this.interiorInfoClone = []
        checkedKeys.forEach(element => {
          const cloneAsset = this.tempInteriorInfoClone.find(
            i => i.assetId === element || i.tenantId === element,
          )
          if (cloneAsset) {
            this.interiorInfoClone.push(cloneAsset)
          }
        })
        this.checkedAll =
          this.tempInteriorInfoClone.length === this.interiorInfoClone.length
      } else {
        this.checkedAll = this.treeData.length === checkedKeys.length
      }
    },

    onChange(key) {
      this.activeKey = key
    },

    openClose(type) {
      this.activeKey = []
      if (type === 'open') {
        this.componentProjectKey++
        this.list.forEach(element => {
          this.activeKey.push(String(element.id))
        })
      }
    },

    onCloneClick(event, asset) {
      this.tenanatCloneData = null
      this.assetId = asset.id
      this.tenantApproachId = asset.tenantApproachId
      this.structureProfileId = asset.structureProfileId
      this.sourceList = []
      this.tempInteriorInfoClone = []
      if (asset.tenants && asset.tenants.length > 0) {
        this.source = asset.tenants[0].tenantId ? asset.tenants[0].tenantId : 0
      } else {
        this.source = 0
      }
      if (this.screenIndentifier === 'Project Interior Info') {
        this.onCloneInteriorInfoScreen()
      } else {
        this.onCloneOtherScreens()
        this.visible = true
      }
      this.selectedKeys = []
      this.checkedAll = false
      event.stopPropagation()
    },

    createTempInteriorInfoClone() {
      this.tempInteriorInfoClone = []
      this.treeData.map(i => {
        if (i.children && i.children.length > 0) {
          i.children.map(element => {
            this.tempInteriorInfoClone.push({
              tenantId: element.tenantId,
            })
          })
        } else {
          if (i.tenants && i.tenants.length > 0) {
            this.tempInteriorInfoClone.push({
              tenantId: i.tenants[0].tenantId,
            })
          } else {
            this.tempInteriorInfoClone.push({
              assetId: i.id,
            })
          }
        }
      })
    },

    onCloneOtherScreens() {
      this.treeData = this.assetsList ? JSON.parse(this.assetsList) : []
      if (this.treeData.length > 0) {
        this.treeData = this.treeData.filter(
          i => i.id !== this.assetId && i.analysisTypeId === 1,
        )
        this.treeData.map(i => {
          i.title = i.description
          i.key = i.id
        })
      }
    },

    onCloneInteriorInfoScreen() {
      switch (this.structureProfileId) {
        case 1:
        case 2:
          this.visible = true
          this.treeData = this.assetsList ? JSON.parse(this.assetsList) : []
          this.onCloneInteriorInfo()
          break

        default:
          switch (this.tenantApproachId) {
            case 1:
              this.treeData = this.assetsList
                ? JSON.parse(this.assetsList)
                : []
              this.sourceList = _.get(
                this.treeData.find(
                  i => i.id === this.assetId && i.analysisTypeId === 1,
                ),
                'tenants',
                [],
              )
              this.source =
                this.sourceList.length > 0
                  ? this.sourceList[0].tenantId
                  : undefined
              this.visible = true
              this.visibleFrom = true
              break
            case 2:
              this.visible = true
              this.treeData = this.assetsList
                ? JSON.parse(this.assetsList)
                : []
              this.onCloneInteriorInfo()
              break
            default:
              showNotification(
                'info',
                'Interior Info Asset Clone',
                'Please select a valid asset!',
              )
              this.visible = false
              break
          }
          break
      }
    },

    onCloneInteriorInfo() {
      if (this.treeData.length > 0) {
        this.treeData = this.treeData.filter(
          i => i.id !== this.assetId && i.analysisTypeId === 1,
        )
        this.treeData.map(i => {
          if (
            i.structureProfileId === 3 &&
            i.tenantApproachId &&
            i.tenantApproachId === 1
          ) {
            Object.assign(i, {
              children: i.tenants.map(x => {
                x.title = x.tenantName
                x.key = x.tenantId
                x.assetId = i.assetId
                return x
              }),
            })
            i.title = i.description
            i.key = i.id
          } else {
            if (i.tenants && i.tenants.length > 0) {
              i.key = i.tenants[0].tenantId
              i.title = i.description
            } else {
              i.title = i.description
              i.key = i.id
            }
          }
        })
        this.createTempInteriorInfoClone()
      }
      this.visibleFrom = false
    },

    cloneTenant(tenantDetails) {
      this.cloneTitle = 'Tenant'
      this.tenanatCloneData = tenantDetails
      this.assetId = tenantDetails.asset.assetId
      this.tenanatIds = tenantDetails.tenanatIds
      this.tenantApproachId = tenantDetails.tenantApproachId
      this.structureProfileId = tenantDetails.structureProfileId
      this.sourceList = []
      this.tempInteriorInfoClone = []
      if (tenantDetails.tenants && tenantDetails.tenants.length > 0) {
        this.source = tenantDetails.tenants[0].tenantId
          ? tenantDetails.tenants[0].tenantId
          : 0
      } else {
        this.source = 0
      }
      if (tenantDetails.asset.analysisTypeId === 1) {
        this.cloneWithRefrestAsset()
      } else if (tenantDetails.asset.analysisTypeId === 2) {
        this.onCloneProjectTenant(tenantDetails.asset.analysisTypeId)
      }
      this.visible = true
      this.selectedKeys = []
      this.checkedAll = false
    },

    onSelectAll(event) {
      if (event.target.checked) {
        this.checkedAll = true
        if (this.screenIndentifier === 'Project Interior Info') {
          this.onSelectAllCloneInteriorInfoAssets()
        } else {
          this.onSelectAllOtherAssets()
        }
      } else {
        this.interiorInfoClone = []
        this.selectedKeys = []
        this.checkedAll = false
      }
    },

    onSelectAllOtherAssets() {
      if (this.tenanatCloneData && this.tenanatCloneData.isTenantClone) {
        this.selectedKeys = this.treeData.map(j => {
          return j.id
        })
      } else {
        this.selectedKeys = this.treeData
          .filter(i => i.id !== this.assetId)
          .map(j => {
            return j.id
          })
      }
    },

    onSelectAllCloneInteriorInfoAssets() {
      this.interiorInfoClone = []
      this.selectedKeys = this.treeData.map(j => {
        return j.key
      })
      this.treeData.map(i => {
        if (i.children && i.children.length > 0) {
          i.children.map(element => {
            this.interiorInfoClone.push({
              tenantId: element.tenantId,
            })
          })
        } else {
          if (i.tenants && i.tenants.length > 0) {
            this.interiorInfoClone.push({
              tenantId: i.tenants[0].tenantId,
            })
          } else {
            this.interiorInfoClone.push({
              assetId: i.id,
            })
          }
        }
      })
    },

    closeDrawer(flag) {
      if (!this.visibleFrom && this.sourceList.length > 0 && !flag) {
        this.visibleFrom = true
      } else {
        this.visible = false
        const data = [...this.list]
        data.forEach(element => {
          element.isCheck = false
          return element
        })
        this.list = data
      }
    },

    showTopButton() {
      const listElm = document.querySelector('#projectdetails')
      listElm.scrollTop = 0
    },

    getProjectAssets() {
      this.loading = true
      this.assetsList = []
      this.list = []
      instance
        .get(projectAPIs.project.asset.list(this.$route.params.id))
        .then(response => {
          _.get(response.data, 'result', []).forEach(element => {
            const asset = this.projectAssets.find(i => i.id === element.id)
            Object.assign(element, {
              actualCostTakeoff: asset ? asset.actualCostTakeoff : 0,
            })
          })
          this.assetsList = JSON.stringify(_.get(response.data, 'result', []))
          const listAssets = _.get(response.data, 'result', [])
          this.list = listAssets
          this.height = calculateHeight('projectdetails', true)
          this.loading = false
          if (this.list.length > 0) {
            this.list.map(data => {
              data.title = data.description
              data.key = data.id
              data.totalCost = 0
            })
            this.setActiveKey(this.list)
          }
          this.$store.commit('PROJECT_ASSETS', {
            assets: 'assets',
            value: JSON.parse(this.assetsList),
          })
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    cloneAssets() {
      if (this.visibleFrom) {
        this.onCloneInteriorInfoAssets()
      } else if (this.tenanatCloneData) {
        this.$root.$emit(
          'popupUpdation',
          true,
          true,
          'Please wait while clone assets...',
        )
        this.cloneProjectTenant()
      } else {
        this.$root.$emit(
          'popupUpdation',
          true,
          true,
          'Please wait while clone assets...',
        )
        this.onCloneOtherAssets()
      }
    },

    onCloneOtherAssets() {
      let url
      let request = []
      this.loadClone = true
      switch (this.screenIndentifier) {
        case 'Project Building General':
          url = projectAPIs.project.asset.buildingGeneral.clone(
            this.$route.params.id,
            this.assetId,
            0,
          )
          request = this.selectedKeys
          break
        case 'Project Building Shell':
          url = projectAPIs.project.asset.buildingShell.clone(
            this.$route.params.id,
            this.assetId,
            0,
          )
          this.selectedKeys.reduce((i, y) => {
            request.push({
              assetId: y,
            })
          }, [])
          break
        case 'Project Speciality Information':
          url = projectAPIs.project.asset.commonArea.clone(
            this.$route.params.id,
            this.assetId,
            0,
          )
          this.selectedKeys.reduce((i, y) => {
            request.push({
              assetId: y,
            })
          }, [])
          break
        case 'Project Site Takeoffs':
          url = projectAPIs.project.asset.siteTakeoff.clone(
            this.$route.params.id,
            this.assetId,
            0,
          )
          this.selectedKeys.reduce((i, y) => {
            request.push({
              assetId: y,
            })
          }, [])
          break
        case 'Project Interior Info':
          url = projectAPIs.project.asset.interiorInfo.clone(
            this.$route.params.id,
            this.assetId,
            0,
            this.source,
          )
          request = this.interiorInfoClone
          break
      }

      instance
        .put(url, request)
        .then(response => {
          this.visible = false
          this.loadClone = false
          this.checkedAll = false
          this.selectedKeys = []
          this.assetId = undefined
          this.tenantApproachId = undefined
          this.structureProfileId = undefined
          if (this.screenIndentifier === 'Project Interior Info') {
            this.getProjectAssets()
          }
        })
        .catch(error => {
          this.loadClone = false
          errorService(error)
        })
    },

    onCloneInteriorInfoAssets() {
      if (this.treeData.length > 0) {
        const infoAssets = this.treeData
        this.treeData = []
        infoAssets.map(i => {
          if (i.structureProfileId === 3) {
            switch (i.tenantApproachId) {
              case 1:
                i.tenants = i.tenants.filter(x => x.tenantId !== this.source)
                if (i.tenants.length > 0) {
                  Object.assign(i, {
                    children: i.tenants.map(x => {
                      x.title = x.tenantName
                      x.key = x.tenantId
                      x.assetId = i.assetId
                      return x
                    }),
                  })
                  i.title = i.description
                  i.key = i.id
                  this.treeData.push(i)
                }
                break
              case 2:
                if (i.tenants && i.tenants.length > 0) {
                  i.title = i.description
                  i.key = i.tenants[0].tenantId
                  this.treeData.push(i)
                }
                break
            }
          } else if (i.tenants && i.tenants.length > 0) {
            i.title = i.description
            i.key = i.tenants[0].tenantId
            this.treeData.push(i)
          } else {
            i.title = i.description
            i.key = i.id
            this.treeData.push(i)
          }
        })
        this.createTempInteriorInfoClone()
      }
      this.visibleFrom = false
    },

    onSelectFrom(event) {
      this.source = event.target.value
    },

    recievedMessage(message) {
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.CloneTenant) {
        this.visible = false
        this.loadClone = false
        this.checkedAll = false
        this.selectedKeys = []
        this.assetId = undefined
        this.tenantApproachId = undefined
        this.structureProfileId = undefined
        this.activeKey = []
        this.getProjectAssets()
      } else if (data.EventType === socketEvents.fileExported) {
        this.$root.$emit('message-received', message)
      } else if (data.EventType === socketEvents.fileImported) {
        this.$root.$emit('message-received', message)
      } else {
        this.$root.$emit('popupUpdation', false, true, null)
        if (data.EventType === socketEvents.error) {
          showNotification('error', 'Socket', data.Message)
        }
        if (data.EventType === socketEvents.projectSidebarUpdated) {
          this.$root.$emit('projectSideBarUpdated', message)
        }
        if (checkEvents(data.EventType)) {
          this.$root.$emit('popupUpdation', false, true, null)
        }
      }
    },

    onCloneProjectTenant(analysisTypeId) {
      this.treeData = this.assetsList ? JSON.parse(this.assetsList) : []
      if (this.treeData.length > 0) {
        this.treeData = this.treeData.filter(
          i => i.structureProfileId === 3 && i.analysisTypeId === analysisTypeId,
        )
        this.treeData.map(i => {
          i.title = i.description
          i.key = i.id
        })
      }
    },

    cloneProjectTenant() {
      if (this.tenanatCloneData.asset.analysisTypeId === 1) {
        instance
          .get(
            projectAPIs.project.asset.buildingGeneral.details(
              this.$route.params.id,
              this.tenanatCloneData.asset.assetId,
            ),
          )
          .then(response => {
            this.formGeneral = _.get(response.data, 'result', null)
            this.loadClone = true
            const url = projectAPIs.project.asset.buildingGeneral.tenant.cloneTenant(
              this.tenanatCloneData.formTenants.projectId,
              this.tenanatCloneData.asset.assetId,
              this.formGeneral.id,
            )
            const objPara = {
              tenantIds: this.tenanatIds,
              assetIds: this.selectedKeys,
            }
            instance.post(url, objPara).then(response => {
              this.tenanatCloneData = null
            })
          })
          .catch(error => {
            this.loadClone = false
            this.loader = false
            errorService(error)
          })
      } else if (this.tenanatCloneData.asset.analysisTypeId === 2) {
        this.loadClone = true
        instance
          .post(this.tenanatCloneData.url, {
            tenantIds: this.tenanatIds,
            assetIds: this.selectedKeys,
          })
          .then(response => {
            this.tenanatCloneData = null
          })
          .catch(error => {
            this.loadClone = false
            errorService(error)
          })
      }
    },

    cloneWithRefrestAsset() {
      instance
        .get(projectAPIs.project.asset.list(this.$route.params.id))
        .then(response => {
          const assetList = JSON.stringify(_.get(response.data, 'result', []))
          this.treeData = this.assetsList ? JSON.parse(assetList) : []
          if (this.treeData.length > 0) {
            this.treeData = this.treeData.filter(
              i => i.tenantApproachId === this.tenantApproachId,
            )
            this.treeData.map(i => {
              i.title = i.description
              i.key = i.id
            })
          }
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    downloadTemplate(event, id) {
      event.stopPropagation()
      this.assetId = id
      this.exportClicked = true
    },

    exportTemplate(id) {
      this.assetId = id
      this.exportClicked = true
    },

    clickedCancel() {
      this.exportClicked = false
    },

    addLevel(event, assetId) {
      event.stopPropagation()
      const count = this.levels.find(i => i.assetId === assetId)
      if (count && count.levelCount < 4) {
        this.$root.$emit('addLevel', assetId)
      } else {
        showNotification('warning', 'Level', 'Maximum 4 levels can add!')
      }
    },

    calulateParentLevelTotal(total, assetId) {
      const assets = [...this.list]
      const index = assets.findIndex(i => i.id === assetId)
      if (index > -1) {
        assets[index].actualCostTakeoff = formatValue(total || 0, 2)
        assets[index].totalCost = formatValue(total || 0, 2)
      }
      this.list = [...assets]
    },

    setLevels(level) {
      const isPresent = this.levels.some(i => i.assetId === level.assetId)
      if (isPresent) {
        const index = this.levels.findIndex(i => i.assetId === level.assetId)
        if (index > -1) {
          this.levels[index].levelCount = level.levelCount
        }
      } else {
        this.levels.push(level)
      }
    },

    setActiveKey(list) {
      let id = 0
      switch (this.screenIndentifier) {
        case 'Project Building Shell':
        case 'Project Interior Info':
        case 'Project Speciality Information':
        case 'Project Site Takeoffs':
          list = list.filter(i => i.analysisTypeId === 1)
          id = list.length > 0 ? list[0].id : undefined
          break
        case 'Project Actual Cost':
          list = list.filter(i => i.analysisTypeId === 2)
          id = list.length > 0 ? list[0].id : undefined
          break
        case 'Project Estimates':
        case 'Project Indirect Cost':
          list = list.filter(i => i.analysisTypeId === 2)
          id = list.length > 0 ? list[0].id : undefined
          break
        default:
          id = this.list[0].id
          break
      }
      const isPresent = this.activeKey.some(i => i === String(id))
      if (!isPresent) {
        this.activeKey.push(String(id))
      }
    },

    cloneSuccess(message) {
      this.visible = false
      this.loadClone = false
      this.checkedAll = false
      this.selectedKeys = []
      this.assetId = undefined
      this.tenantApproachId = undefined
      this.structureProfileId = undefined
      this.getProjectAssets()
    },

    orderingTiles(event, assetId) {
      event.stopPropagation()
      this.$root.$emit('orderingTiles', assetId)
    },

    showEstimateInfo(event, id) {
      event.stopPropagation()
      this.url = projectAPIs.project.asset.estimate.info(
        this.$route.params.id,
        id,
      )
      this.visibleEstimateInfo = !this.visibleEstimateInfo
    },

    closeEstimateInfo() {
      this.visibleEstimateInfo = false
    },

    checkEstimateGroups(count) {
      this.estimateInfoCount = count
    },

    showIndirectCostInfo(event, details) {
      event.stopPropagation()
      this.url = projectAPIs.project.asset.indirectCost.info(
        this.$route.params.id,
        details.id,
      )
      this.assetId = details.id
      this.assetDescription = details.description
      this.visibleIndirectCostInfo = !this.visibleIndirectCostInfo
    },

    closeIndirectCostInfo() {
      this.visibleIndirectCostInfo = false
      this.assetId = undefined
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },
  },
}
